import { Button, Layout } from 'antd';
import { LoadingScreen, PageNotFound } from 'components/Atoms';
import { Header, SideBar } from 'components/Organisms';
import { useGetDemographicList } from 'components/Pages/Library/components/Audiences/services';
import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import renderRoutes from 'routers/render';
import * as routePath from 'routers/route-path';
import './styles.scss';
import useBreadcrumb from 'hooks/useBreadcrumb';
import { isMobile } from 'utilities/common';
import cn from 'classnames';
import { useLocation } from 'react-use';
import { usePendo } from 'hooks/usePendo';
import { ACCOUNT_ROLE_ON_URL } from 'constants/url';
import { USER_LEVEL_TYPE } from 'constants/common';
import { FormattedMessage } from "react-intl";

const { Content } = Layout;

const PrivateLayout = ({ userInfo, ...rest }) => {
  const [collapsed, setCollapsed] = useState(false);
  let history = useHistory();
  const { breadcrumbs } = useBreadcrumb();
  //service
  const { data } = useGetDemographicList();
  const location = useLocation();
  const pendo = usePendo();

  const _onCollapse = () => {
    setCollapsed(!collapsed);
  };

  // Handle sidebar collapse state from SideBar component
  const handleSidebarCollapse = (isCollapsed) => {
    setCollapsed(isCollapsed);
  };
  useEffect(() => {
    if (!userInfo || !pendo) {
      return;
    }

    pendo?.initialize({
      visitor: {
        id: userInfo.id,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
      },

      account: {
        id: userInfo.customerId, // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
        name: userInfo.companyName, // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
        // planLevel:    // Optional
        // planPrice:    // Optional
        // creationDate: // Optional

        // You can add any additional account level key-values here,
        // as long as it's not one of the above reserved names.
      },
      excludeAllText: true,
    });
  }, [userInfo, pendo]);

  useEffect(() => {
    // Create a script element
    // if (process.env.NODE_ENV === 'development') {
    //   return;
    // }

    const script = document.createElement('script');
    script.src = 'https://cdn.usemevo.com/mevo-sdk.min.js';
    script.setAttribute('bid', '67e6ce7d6902cd02743d8bc9');
    script.async = true;

    // Append the script to the body
    document.head.appendChild(script);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <Layout className="site-layout">
      {!isMobile && (
        <SideBar
          collapsed={collapsed}
          onCollapseChange={handleSidebarCollapse}
        />
      )}
      <Layout className={cn('page-layout', { 'sidebar-collapsed': collapsed })}>
        <Header
          className="site-layout-background"
          style={{ padding: 0 }}
          collapsed={collapsed}
          onCollapse={_onCollapse}
        />
        {/* {!isMobile && breadcrumbs} */}
        <Content
          className={cn('page-content', {
            mobile: isMobile,
            'getting-started': location.pathname.includes(
              routePath.STARTED_PAGE
            ),
            analytics:
              location.pathname.includes(
                routePath.ANALYTICS.replace(':accountRole', '')
              ) || location.pathname.includes('analytic'),
          })}
        >
          <div
            className={cn('content', {
              'pb-0':
                location.pathname === routePath.CREATE_AUDIENCE_CUSTOM ||
                location.pathname.includes(
                  routePath.EDIT_AUDIENCE_CUSTOM.replace(':id', '')
                ) ||
                location.pathname === routePath.CREATE_AUDIENCE,
            })}
          >
            <Switch>
              {renderRoutes(true, userInfo)}
              <Route exact path="/">
                <Redirect
                  to={isMobile ? routePath.CAMPAIGNS : routePath.STARTED_PAGE}
                />
              </Route>
              <Route path="*">
                {userInfo ? (
                  <PageNotFound
                    extra={
                      <div className="text-center">
                        <p><FormattedMessage id={"page_not_found.title"}/></p>
                        <Button
                          className="btn-primary-custom"
                          onClick={() => {
                            if (
                              userInfo.level ===
                              USER_LEVEL_TYPE.ANALYTIC_MANAGER
                            ) {
                              history.replace(
                                routePath.ANALYTICS.replace(
                                  ':accountRole',
                                  ACCOUNT_ROLE_ON_URL[userInfo.role]
                                )
                              );
                            } else {
                              history.replace('/');
                            }
                          }}
                        >
                          <FormattedMessage id={"page_not_found.back_home"}/>
                        </Button>
                      </div>
                    }
                  />
                ) : (
                  <LoadingScreen />
                )}
              </Route>
            </Switch>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

PrivateLayout.propTypes = {};

export default PrivateLayout;
